      function setCookie(name, value, hours) {
        const d = new Date();
        d.setTime(d.getTime() + (hours * 60 * 60 * 1000));
        const expires = "expires=" + d.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
      }
    
      function getCookie(name) {
        const cookieName = name + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArray = decodedCookie.split(';');
        for (let i = 0; i < cookieArray.length; i++) {
          let cookie = cookieArray[i];
          while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1);
          }
          if (cookie.indexOf(cookieName) === 0) {
            return cookie.substring(cookieName.length, cookie.length);
          }
        }
        return "";
      }
    
      function getRandomNumber(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      }
    
      function updatestockCount() {
        const productId = document.body.getAttribute("data-product_id");
        if(!productId) return;

        const cookieName = "stockCount_" + productId;
        let stockCount = getCookie(cookieName);
    
        if (stockCount === "") {
          stockCount = getRandomNumber(3, 11);
          setCookie(cookieName, stockCount, 1);
        }
    
        const elements = document.getElementsByClassName("stockCount");
        for (let i = 0; i < elements.length; i++) {
          elements[i].textContent = stockCount;
        }
      }
    
      updatestockCount();